import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, ApiError } from '../lib/api';
import { useAuth } from '../lib/auth';

export function TwoFactorPage() {
  const [code, setCode] = useState('');
  const [isBackup, setIsBackup] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const { refresh } = useAuth();

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.post('/auth/2fa/verify', { code, isBackupCode: isBackup });
      await refresh();
      nav('/');
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'Verbindungsfehler');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <h1 className="text-xl font-bold text-slate-900">Zwei-Faktor-Authentifizierung</h1>
          <p className="text-sm text-slate-500 mt-1">
            {isBackup ? 'Backup-Code eingeben' : 'Code aus der Authenticator-App'}
          </p>
        </div>

        <form onSubmit={submit} className="card space-y-4">
          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-md px-3 py-2">
              {error}
            </div>
          )}

          <div>
            <label className="label" htmlFor="code">
              {isBackup ? 'Backup-Code' : '6-stelliger Code'}
            </label>
            <input
              id="code"
              type="text"
              inputMode={isBackup ? 'text' : 'numeric'}
              pattern={isBackup ? undefined : '[0-9]{6}'}
              maxLength={isBackup ? 11 : 6}
              className="input text-center text-lg tracking-widest"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              required
              autoFocus
              autoComplete="one-time-code"
            />
          </div>

          <button type="submit" disabled={loading} className="btn-primary w-full">
            {loading ? 'Prüfe ...' : 'Bestätigen'}
          </button>

          <button
            type="button"
            onClick={() => { setIsBackup(!isBackup); setCode(''); setError(''); }}
            className="text-sm text-rla-500 hover:underline w-full text-center"
          >
            {isBackup ? 'Authenticator-Code verwenden' : 'Backup-Code verwenden'}
          </button>
        </form>
      </div>
    </div>
  );
}
